import { useEffect } from 'react';
import type { ClientProductEventInput } from '@scoutaround/script-breakdown-shared';

import { track } from '../lib/telemetry.js';

/**
 * Records `eventName` once per distinct props value while mounted. Renders nothing.
 *
 * Keyed on the serialized props, so a re-render with an equal object literal is
 * not a second view.
 */
export function TrackView({
  projectId,
  eventName,
  props,
}: {
  projectId: string;
  eventName: ClientProductEventInput['eventName'];
  props: ClientProductEventInput['props'];
}) {
  const key = JSON.stringify(props);
  useEffect(() => {
    track(projectId, eventName, JSON.parse(key) as ClientProductEventInput['props']);
  }, [projectId, eventName, key]);
  return null;
}

/** Setup drop-off (gap 25): a step entered, and left with the time spent in it. */
export function TrackSetupStep({ projectId, step }: { projectId: string; step: string }) {
  useEffect(() => {
    const entered = Date.now();
    track(projectId, 'setup_step_entered', { step });
    return () => {
      track(projectId, 'setup_step_left', { step, duration_ms: Date.now() - entered });
    };
  }, [projectId, step]);
  return null;
}
